<template>
  <div>
    <cms-programs
      v-if="programsSetUp"
      :theme="programOptions"
      :content="homepage.programs[id]"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { isEmpty } from 'lodash';

defineOptions({ name: 'ViewPrograms' });

const props = defineProps({
  containerIdx: {
    type: Number,
    default: null,
  },
  containerId: {
    type: String,
    default: null,
  },
  componentIdx: {
    type: Number,
    default: null,
  },
});

const store = useStore();

const homepage = computed(() => store.state.homepage);
const theme = computed(() => store.state.theme);
const isThemePreview = computed(() => store.state.isThemePreview);

const id = computed(() => {
  if (isThemePreview.value) {
    return 'preview_id';
  }
  return `${props.containerId}_${props.componentIdx}`;
});

const programOptions = computed(() => {
  if (!theme.value?.containers) return {};
  return {
    ...theme.value.containers[props.containerIdx].components[props.componentIdx].options,
    translations: store.getters['translation/getComponentTranslation']('programs'),
    globalThemeSettings: store.getters.getGlobalThemeSettings,
  };
});

const programsSetUp = computed(() => !isEmpty(homepage.value?.programs?.[id.value]?.content));
</script>
